(function () {
  var KEY = 'hado_ep_v1';        // set once dismissed or converted
  var DELAY = 7000;              // first-visit auto-show after 7s
  var ov = document.getElementById('emailPopup');
  if (!ov) return;

  var shown = false;
  function seen() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  function open() {
    if (shown) return;
    shown = true;
    ov.classList.add('on');
    ov.removeAttribute('inert');
    ov.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ep-lock');
    // Focus the dialog, not the email field: focusing the field pops the mobile keyboard and makes
    // Shopify load hCaptcha (~900 KB) for a form the shopper may never use.
    var dlg = ov.querySelector('.ep');
    if (dlg) { dlg.setAttribute('tabindex', '-1'); setTimeout(function () { dlg.focus({ preventScroll: true }); }, 120); }
  }
  function close() {
    ov.classList.remove('on');
    ov.setAttribute('inert', '');
    ov.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ep-lock');
    if (!seen()) remember('dismissed');
  }

  function showSuccess() {
    var w = ov.querySelector('[data-ep-form-wrap]');
    var s = ov.querySelector('[data-ep-success]');
    if (w) w.hidden = true;
    if (s) s.hidden = false;
    remember('converted');
  }

  // 1. Returning from Shopify after a successful submit → reopen in success state
  if (/[?&]customer_posted=true/.test(location.search)) {
    showSuccess();
    open();
    // GA4 / dataLayer signal
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'generate_lead', method: 'email_popup' });
  } else if (!seen()) {
    // 2. First-visit triggers: timed OR exit-intent, whichever fires first
    var t = setTimeout(open, DELAY);
    var onExit = function (e) {
      if (e.clientY <= 0) { clearTimeout(t); open(); document.removeEventListener('mouseout', onExit); }
    };
    document.addEventListener('mouseout', onExit);
  }

  // Close interactions
  ov.addEventListener('click', function (e) {
    if (e.target === ov || e.target.closest('[data-ep-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ov.classList.contains('on')) close();
  });

  // Copy code
  var codeBtn = ov.querySelector('[data-ep-code]');
  if (codeBtn) {
    codeBtn.addEventListener('click', function () {
      var txt = 'WELCOME10';
      var done = function () {
        var lbl = codeBtn.querySelector('.ep-copy');
        if (lbl) { lbl.textContent = 'Copied!'; setTimeout(function () { lbl.textContent = 'Tap to copy'; }, 2000); }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(txt).then(done, done);
      } else { done(); }
    });
  }

  // Mark intent on submit so we don't re-nag even if redirect param is missed
  var form = ov.querySelector('#epForm');
  if (form) form.addEventListener('submit', function () { remember('converting'); });
})();
